import React, { useEffect, useState } from 'react';
import { Container, Header, Segment, Button, Modal, Pagination, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'

import TitleBar from '../titleBar/titleBar';
import AgGridTable from '../agGridComponent/agGridTable';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import EditModal from '../modals/editModal';
import BillApprovalModal from './billApprovalModal';

import CustomerInvoiceActionButton from './customerInvoiceActionButton';
import PaymentActionButton from './paymentActionButton';


//Redux Actions
import { deleteCustomerInvoice, getCustomerInvoice, getFilteredCustomerInvoice, getPenalties} from '../../redux/actions/customerInvoiceActions';
import { getCustomerSalesOrder, clearSelectSoData } from '../../redux/actions/salesOrderActions';
import { approveBills, rejectBills } from '../../redux/actions/approvalActions';
import PenaltiesActionButton from './penaltiesActionButton';
import PdfActionButton from './pdfActionButton';
import { getGeneratedPdf } from '../../redux/actions/customerInvoiceActions';
import { isIRNCodeEnable } from '../../Features/features';


function CustomerInvoiceTable(props) {

    const { customerInvoiceData, customerInvoiceLoading, getCustomerInvoice, deleteCustomerInvoice,
        deleteCustomerInvoiceIsLoading, getCustomerSalesOrder, approveBills, rejectBills, getFilteredCustomerInvoice, getPenalties,
        penaltiesData, penaltiesLoading, paginationData, clearSelectSoData } = props;

    const [selectedRows, setSelectedRows] = useState([]);
    const [activeSelect, setActiveSelect] = useState(false);
    const [grid, setGrid] = useState({});
    const [openApprovalModal, setOpenApprovalModal] = useState(false);
    const [searchValue, setSearchValue] = useState('')
    const [ClientCode, setClientCode] = useState(null)
    const [BranchCode, setBranchCode] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState()
    const [itemCount, setItemCount] = useState(10)
    const [loadingData, setLoadingData] = useState(false)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [rowData, setRowData] = useState([])
    let perPageItems = [
        {
            key: "1",
            text: "10",
            value: "10",
        },
        {
            key: "2",
            text: "20",
            value: "20",
        },
        {
            key: "3",
            text: "30",
            value: "30",
        },
        {
            key: "4",
            text: "50",
            value: "50",
        },
    ];

    useEffect(() => {
        getCustomerInvoice()

    }, []);

    useEffect(() => {
        clearSelectSoData()
    }, [])

    useEffect(() => {
        if (paginationData) {
            setCurrentPage(paginationData.currentPage)
            setItemsPerPage(paginationData.itemsPerPage)
            setItemCount(paginationData.totalItems)
            setTotalPages(paginationData.totalPages)
        }
    }, [paginationData])



    const getSelectedRows = (grid) => {

        const selected = grid.api.getSelectedRows()
        setGrid(grid)

        setSelectedRows(selected);
        if (selected.length > 0) {
            setActiveSelect(true)
        } else {
            setActiveSelect(false)
        }
    };

    const filterSales = (payload) => {       
        getFilteredCustomerInvoice()
        setSearchValue(payload?.search_value);
        setClientCode(payload?.client_code?.toString());
        setBranchCode(payload?.branch_code);
        getCustomerInvoice(
            itemsPerPage,
            payload?.search_value,
            1,
            null,
            payload?.client_code?.toString(),
            payload?.branch_code,
        );
    };

    const handleCloseBillApproval = () => {
        setOpenApprovalModal(false)
    };


    const handleOpenApprovalModal = () => {
        setOpenApprovalModal(true)
    };

    const approveBillsSelected = (billDetails) => {
        const approvalData = {
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            billDetails: billDetails
        }

        approveBills(approvalData);
    }

    const rejectBillsSelected = () => {

        let billDetails = [];
        selectedRows && selectedRows.map((o, i) => {
            let temp = {};
            temp.billReferenceNo = o.refNo
            temp.vendorCode = o.vendorCode
            temp.approvalStatus = "Rejected"

            billDetails[i] = temp
        })

        const rejectData = {
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            billDetails: billDetails
        }

        rejectBills(rejectData)
    }

    const handleSelectAll = () => {
        grid.api.selectAll()
    }

    const handleUnSelectAll = () => {
        grid.api.deselectAll()
    }

    const handleCancel = () => {
        grid.api.deselectAll();
        setActiveSelect(false);
    }

    const getFilterDates = (startDate, endDate) => {
        const filteredData = {
            api_token: localStorage.getItem('apiToken'),
            customer_no: localStorage.getItem('customerNo'),
            user_id: localStorage.getItem('userId'),
            fromDate: moment(startDate).format("DD-MM-YYYY"),
            toDate: moment(endDate).format("DD-MM-YYYY")
        }

        getFilteredCustomerInvoice(filteredData)
    }

    const refreshDates = () => {
        window.location.reload();
    }

    const handlePaginationChange = (e, { activePage }) => {
        setCurrentPage(activePage)
        setLoadingData(true)
        setRowData([])
        getCustomerInvoice(itemsPerPage, searchValue, activePage, null, ClientCode, BranchCode)
    }

    const handlePagination = (e, data) => {
        e.stopPropagation()
        setRowData([])
        setCurrentPage(1)
        setItemsPerPage(data.value)
        getCustomerInvoice(data.value, searchValue, 1, null, ClientCode, BranchCode)
    }


    if (customerInvoiceLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Customer Invoice" LinkName="add-customerinvoice" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = isIRNCodeEnable() ? [
            { headerName: 'Customer Invoice No.', field: 'customerInvoiceNo', cellRenderer: 'paymentModalRenderer', tooltipField: 'customerInvoiceNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'IRN Code', field: 'irnCode', tooltipField: 'irnCode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Customer Invoice Date', field: 'customerInvoiceDate', tooltipField: 'customerInvoiceDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Customer Name', field: 'customerName', tooltipField: 'customerName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Invoice Amount', field: 'invoiceAmount', tooltipField: 'invoiceAmount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Pending Amount', field: 'pendingAmount', tooltipField: 'pendingAmount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Expected Payment Date', field: 'expectedPaymentDate', tooltipField: 'expectedPaymentDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Remarks', field: 'remarks', tooltipField: 'remarks', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'PDF', field: 'pdf', cellRenderer: 'pdfRenderer', suppressToolPanel: true, pinned: "right" },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, pinned: "right" }
        ] : [
            { headerName: 'Customer Invoice No.', field: 'customerInvoiceNo', cellRenderer: 'paymentModalRenderer', tooltipField: 'customerInvoiceNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Customer Invoice Date', field: 'customerInvoiceDate', tooltipField: 'customerInvoiceDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Customer Name', field: 'customerName', tooltipField: 'customerName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Invoice Amount', field: 'invoiceAmount', tooltipField: 'invoiceAmount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Pending Amount', field: 'pendingAmount', tooltipField: 'pendingAmount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Expected Payment Date', field: 'expectedPaymentDate', tooltipField: 'expectedPaymentDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Remarks', field: 'remarks', tooltipField: 'remarks', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'PDF', field: 'pdf', cellRenderer: 'pdfRenderer', suppressToolPanel: true, pinned: "right" },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, pinned: "right" }
        ];

        let frameworkComponents = {
            actionRenderer: CustomerInvoiceActionButton,
            paymentModalRenderer: PaymentActionButton,
            penaltiesModalRenderer: PenaltiesActionButton,
            pdfRenderer: PdfActionButton
        }

        // let rowData = []

        customerInvoiceData && customerInvoiceData.forEach((object, index) => {
            let temp = {}
            temp.customerInvoiceNo = object.invoice_no
            temp.customerInvoiceDate = moment(object.invoice_date).format('DD-MM-YYYY')
            temp.refNo = object.reference_number
            temp.customerName = object.client_name
            temp.customerCode = object.client_code
            temp.invoiceAmount = object.invoice_amt
            temp.vendorName = object.vendorName
            temp.vendorGroup = ''
            temp.billAmount = object.billAmount
            temp.pendingAmount = object.pending_amt
            temp.expectedPaymentDate = moment(object.expectedPaymentDate).format('DD-MM-YYYY')
            temp.status = object.approvalStatus
            temp.remarks = object.remarks
            temp.createdOn = object.created_at
            temp.createdBy = object.created_by_name
            temp.modifiedOn = object.updated_at
            temp.modifiedBy = object.updated_by_name
            temp.totalPenaltyAmt = object.totalPenaltyAmt
            temp.deleteCustomerInvoice = deleteCustomerInvoice
            temp.isLoading = deleteCustomerInvoiceIsLoading
            temp.getCustomerSalesOrder = getCustomerSalesOrder
            temp.getPenalties = getPenalties
            temp.penaltiesData = penaltiesData
            temp.penaltiesLoading = penaltiesLoading
            //Extra Data for Edit
            temp.vendorCode = object.vendorCode
            temp.billPO = object.bill_po_mapping
            temp.invoiceId = object.id
            temp.statusId = object.status_id
            rowData[index] = temp
        })

        const pendingCustomerInvoice = customerInvoiceData ? customerInvoiceData.filter(customerInvoice => customerInvoice.approvalStatus === 'Pending').length : ''
        const approvedCustomerInvoice = customerInvoiceData ? customerInvoiceData.filter(customerInvoice => customerInvoice.approvalStatus === 'Approved').length : ''
        const rejectedCustomerInvoice = customerInvoiceData ? customerInvoiceData.filter(customerInvoice => customerInvoice.approvalStatus === 'Rejected').length : ''

        const approvalData = {
            pending: pendingCustomerInvoice,
            approved: approvedCustomerInvoice,
            rejected: rejectedCustomerInvoice
        }

        const newPopup = () => {
            props.history.push('/add-customerinvoice')
        }

        return (
            <React.Fragment>
                <div style={{ position: 'relative' }}>

                    <AgGridTable
                        ClientCode={ClientCode}
                        BranchCode={BranchCode}
                        customizedSearch={true}
                        columnDefs={columnDefs}
                        uniqueRowData={rowData}
                        searchValue={searchValue}
                        link="/add-customerinvoice"
                        baseURL={props}
                        newPopup={newPopup}
                        hiddenNewPopupBtn={false}
                        hiddenImportPopupBtn={true}
                        extraComponents={frameworkComponents}
                        titleBarTitle="Customer Invoice"
                        rowSelected={getSelectedRows}
                        approvalCountSection={true}
                        approvalData={approvalData}
                        dateFilter={true}
                        getFilterDates={getFilterDates}
                        refreshDates={refreshDates}
                        suppressRowSelection={true}
                        removeStatus={true}
                        pagination={false}
                        setFilterValues={filterSales}
                    />
                    <div className="life-cycle w3-white ui pagination menu" style={{ zIndex: 1 }}>
                        <Pagination
                            defaultActivePage={currentPage}
                            firstItem={null}
                            lastItem={null}
                            onPageChange={handlePaginationChange}
                            pointing
                            secondary
                            totalPages={totalPages}
                        />
                        <Dropdown
                            options={perPageItems}
                            size="mini"
                            className="m-1"
                            placeholder="10"
                            selection
                            value={itemsPerPage}
                            defaultValue={"10"}
                            onChange={handlePagination}
                            compact
                        />
                    </div>

                    {activeSelect ?


                        <Segment
                            style={{ bottom: 22, left: 0, zIndex: 0 }}
                        >

                            <span style={{ color: 'grey', fontSize: '14px' }}>{`Selected (${selectedRows.length}/${customerInvoiceData.length}) `}</span>
                            {selectedRows.length === customerInvoiceData.length ?
                                <Button onClick={handleUnSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>UnSelect All</Button>
                                :
                                <Button onClick={handleSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>Select All</Button>

                            }
                            <Button onClick={handleOpenApprovalModal} size="mini" basic color="blue" style={{ marginLeft: '5px', borderRadius: '25px' }}>Approve</Button>
                            <Button onClick={rejectBillsSelected} size="mini" basic color="red" style={{ marginLeft: '5px', borderRadius: '25px' }}>Reject</Button>
                            <Button type="button" onClick={handleCancel} size="mini" style={{ marginLeft: '5px', borderRadius: '25px' }}>Cancel</Button>
                            <EditModal size="large" open={openApprovalModal} onClose={handleCloseBillApproval}>
                                <Modal.Header>Approval</Modal.Header>
                                <BillApprovalModal
                                    selectedRows={selectedRows}
                                    handleCloseBillApproval={handleCloseBillApproval}
                                    approveBillsSelected={approveBillsSelected}
                                />
                            </EditModal>
                        </Segment>

                        :

                        <div style={{ height: '20px' }}></div>
                    }
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    customerInvoiceData: state.getCustomerInvoiceData.customerInvoice.data,
    paginationData: state.getCustomerInvoiceData.customerInvoice.pagination,
    customerInvoiceLoading: state.getCustomerInvoiceData.isLoading,
    deleteCustomerInvoiceIsLoading: state.deleteCustomerInvoiceData.isLoading,
    penaltiesData: state.getPenaltiesData.billPenalties.data,
    penaltiesLoading: state.getPenaltiesData.isLoading
})

export default connect(mapStatetoProps, { getCustomerInvoice, deleteCustomerInvoice, getCustomerSalesOrder, approveBills, rejectBills, getFilteredCustomerInvoice, getPenalties, clearSelectSoData })(CustomerInvoiceTable)